export const TENANT_DEMO = {
  id: 'tnt_demo',
  slug: 'centrio',
  name: 'Centrio',
  status: 'active',
  primaryHostname: 'centrio.skeleton-store.com',
  defaultCurrency: 'COP',
  defaultLocale: 'es-CO',
  plan: { id: 'pro', name: 'Pro', price: 299000, currency: 'COP' },
  branding: {
    primaryColor: '#f97316',
    logo: 'https://picsum.photos/seed/logo/240/80',
    favicon: null,
  },
  metadata: {
    modules: 'loyalty,blog,reviews,affiliates',
    onboardingState: 'completed',
  },
  createdAt: '2026-01-12T10:30:00.000Z',
  updatedAt: '2026-04-22T14:15:00.000Z',
  ownerEmail: 'owner@centrio.com',
  storefrontUrl: 'https://centrio.skeleton-store.com',
}
